import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-storywall',
    templateUrl: './storywall.component.html',
    styleUrls: ['./storywall.component.css']
  })
export class StorywallComponent implements OnInit {
  time :any={};
  tool_obj:any={type:'-2',search_model:'',lock_status:'-2',kyc_status:'-1',process_action:'-1',gender_action:'-2',identity_action:'-2',chosen_action:'0',chosen1_action:'0',process_list:[]}
  data:any=[];
  time_info:any=-1;
  top_info:any={};
  link:string = environment.link;
  edit_data:any=[]
  user:any=[]
  now:any = '3';
  loading:boolean=true;
  pageobj:page = {page:0,count:36,total_count:0};
  menu_list:menulist = [
    // {id:'2',name:'女精選新動態'},
    // {id:'1',name:'動態列表'},
    {id:'3',name:'男檢查動態'},
    {id:'4',name:'女檢查動態'}
  ];
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  lock_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'0',name:'免費動態'},
    {id:'1',name:'付費動態'},
  ];
  kyc_option_list:menulist=[
    {id:'-2',name:'kfc狀態'},
    {id:'-1',name:'全部'},
    {id:'0',name:'沒過kyc'},
    {id:'1',name:'有過kyc'},
  ];
  process_option_list = [
    {id:'-1',name:'上鎖',type:3,value:200},
    {id:'-2',name:'下架',type:1,value:-4},
    // {id:'-99',name:'盜圖下架',type:1,value:-99},
    {id:'6',name:'盜圖',type:1,value:6},
    {id:'1',name:'免費',type:3,value:0},
    {id:'2',name:'上架',type:1,value:1},
    {id:'4',name:'已審核',type:4,value:Dep.user.id},
  ];


  gender_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'1',name:'男生'},
    {id:'2',name:'女生'},
  ];
  identity_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'1',name:'一般'},
    {id:'3',name:'經紀'},
  ];

  type_option_list:menulist=[
    {id:'0',name:'全部'},
    {id:'3',name:'圖片'},
    {id:'4',name:'影片'},
  ];

  manage_option_list:menulist=[];
  manage_action = '-1';

  chosen_option_list:menulist=[
    {id:'-2',name:'全部'},
    {id:'-1',name:'非精選'},
    {id:'0',name:'待審核'},
    {id:'1',name:'精選'},
  ];

  check_status_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'0',name:'已審核'},
    {id:'1',name:'未審核'},
  ];
  check_status_action = '1';

  timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
  showDatePickersTatus = true;

  alert_list = [];
  alert_pic_list = [];
  data_list = [];
  selectedDateTime: string;

  ranges: any = {
    '今天': [moment(), moment()],
    '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '過去一周': [moment().subtract(6, 'days'), moment()],
    '過去30天': [moment().subtract(29, 'days'), moment()],
    '本月': [moment().startOf('month'), moment().endOf('month')],
    '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }

  checkUrl:any = [];


  constructor(
    public httpClient: HttpClient,
  ) {
    const currentDate = new Date();
    this.selectedDateTime = this.formatDateTime(currentDate);

   }

   private formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    //return `${year}-${month}-${day}T${hours}:${minutes}`;
    return `${year}-${month}-${day} ${hours}:${minutes}:00`;
  }


  trackByFn(i: number, item: any): any { return item ? (item.id ?? item.user_id ?? i) : i; }

  ngOnInit(): void {
    this.user = Dep.user;
    this.init_list();
  }

  handleImageUpload(file: File ,bi: any,i: any): void {
    this.data[bi].data[i].tmp_checkUrl = file;
 }


  handleRangeSelected( value: any ): void {

    let  eventDate = value.event;

    if(this.showDatePickersTatus){
        this.time.startDate = moment().subtract(7, 'days');
        this.time.endDate = moment().subtract(0, 'days');
        this.time.start = moment(this.time.startDate);
        this.time.end = moment(this.time.endDate);
    }else{
        this.time.startDate = '';
        this.time.endDate = '';
        this.time.start = '';
        this.time.end = '';
    }

    if(eventDate.startDate){
        this.time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
        this.time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
    }
    this.showDatePickersTatus = !this.showDatePickersTatus;
    this.init_list();
  }

  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,search:this.tool_obj.search_model,now_range:this.time,tool:this.tool_obj,now:this.now,check_status_action:this.check_status_action,manage_action:this.manage_action};
    this.httpClient.post<any>("/get_storywall_list.php",body).subscribe(res => {
    console.log('res',res);
      this.loading = false;
      this.manage_option_list = res.vlist;
      this.data = res.data
      this.top_info = res.top_info
      this.pageobj.total_count = res.total_count
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    }, error => {
      console.log(error);
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  onRangeSelected(type,value: any) {
    if(value.startDate){
      this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
      this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
      this.init_list();
    }
  }

  choose(value:string){
    console.log('value',value);
    this.data_list = [];
    this.tool_obj.chosen1_action = '0';
    this.now = value;
    this.pageobj.page = 0;
    this.check_status_action = '1';
    this.tool_obj.process_list = [];//重歸0
    if(value=='1'){//審核換全部
      this.tool_obj.lock_status = '-2';
      this.tool_obj.chosen_action = '-3';
      this.tool_obj.identity_action = '-2';
      this.tool_obj.process_action = '-1';
      this.tool_obj.gender_action = '-2';
      this.process_option_list = [
        {id:'-1',name:'上鎖',type:3,value:200},
        {id:'-2',name:'下架',type:1,value:-4},
        // {id:'-99',name:'盜圖下架',type:1,value:-99},
        {id:'6',name:'盜圖',type:1,value:6},
        {id:'-3',name:'取消精選',type:2,value:0},
        {id:'1',name:'免費',type:3,value:0},
        {id:'2',name:'上架',type:1,value:1},
        {id:'3',name:'精選',type:2,value:1},
        {id:'4',name:'已審核',type:4,value:Dep.user.id},
      ];

      this.chosen_option_list=[
        {id:'-3',name:'精選種類'},
        {id:'-2',name:'全部'},
        {id:'-1',name:'非精選'},
        {id:'0',name:'待審核'},
        {id:'1',name:'精選'},
      ];
    }else if(value=='2'){//更換filter
      this.tool_obj.chosen_action = '0';
      this.tool_obj.lock_status = '-2';
      this.tool_obj.gender_action = '-2';
      this.tool_obj.process_action = '3';
      this.tool_obj.identity_action = '-2';
      this.process_option_list = [
        {id:'3',name:'精選',type:2,value:1},
        {id:'4',name:'非精選',type:2,value:-1},
      ];
      this.chosen_option_list=[
        {id:'-2',name:'全部'},
        {id:'-1',name:'非精選'},
        {id:'0',name:'待審核'},
        {id:'1',name:'精選'},
      ];
    }else{
        console.log('value',value);
      this.tool_obj.chosen_action = '-2';
      this.tool_obj.lock_status = '0';
      this.tool_obj.identity_action = '-2';

      if(value == '4'){
        this.process_option_list = [
            {id:'-1',name:'上鎖',type:3,value:200},
            {id:'-2',name:'下架',type:1,value:-4},
            // {id:'-99',name:'盜圖下架',type:1,value:-99},
            {id:'6',name:'盜圖',type:1,value:6},
            {id:'1',name:'免費',type:3,value:0},
            {id:'2',name:'上架',type:1,value:1},
            {id:'3',name:'已審核',type:4,value:Dep.user.id},
            {id:'4',name:'精選',type:2,value:1},
            {id:'5 ',name:'非精選',type:2,value:-1},
          ];
      }else{
        this.process_option_list = [
            {id:'-1',name:'上鎖',type:3,value:200},
            {id:'-2',name:'下架',type:1,value:-4},
            // {id:'-99',name:'盜圖下架',type:1,value:-99},
            {id:'6',name:'盜圖',type:1,value:6},
            {id:'1',name:'免費',type:3,value:0},
            {id:'2',name:'上架',type:1,value:1},
            {id:'3',name:'已審核',type:4,value:Dep.user.id},
        ];
      }

      this.chosen_option_list=[
        {id:'-2',name:'全部'},
        {id:'-1',name:'非精選'},
        {id:'0',name:'待審核'},
        {id:'1',name:'精選'},
      ];

      if(value=='3'){//男生1
        this.tool_obj.gender_action = '-2';
        this.tool_obj.identity_action = '-2';
        // 還原成首次進頁的預設（lock=全部、待審核）；沿用上面 else 分支的 lock_status='0'
        // 會變成「男+免費」，而男生免費未審為 0 筆 → 切回此頁籤永遠無資料
        this.tool_obj.lock_status = '-2';
        this.tool_obj.chosen_action = '0';
      }else{
        this.tool_obj.gender_action = '2';
        this.tool_obj.identity_action = '-2';
        this.tool_obj.chosen1_action = '-2';
        this.check_status_action = '-1';
      }
    }
    this.init_list();
  }

  alert_item(item,act,id){
    const index = this.alert_list.findIndex((v)=>{
        return v == item.id;
    })

    if(index!=-1){
        this.alert_list.splice(index,1);
        this.data_list.splice(index,1);
    }else if(act == 1){
        this.alert_list.push(item.id);
        if(this.now=='3'||this.now=='4'){
            item.validate_employee_id = id
        }
        this.data_list.push(item)
    }


  }

  choose_item(item){
    const index = this.tool_obj.process_list.findIndex((v)=>{
      return v == item.id;
    })
    if(index==-1){
      this.tool_obj.process_list.push(item.id);
    }else{
      this.tool_obj.process_list.splice(index,1)
    }
  }

  choose_all(type){
    if(type){
      this.data.forEach(element => {
        element.data.forEach(e =>{
          this.tool_obj.process_list.push(e.id)
        })
      });
    }else{
      this.tool_obj.process_list = [];
      this.alert_list = [];
      this.data_list = [];
    }
  }

  middle_save(item){

    let column = '';
    if(item.type==1){
      column = 'is_enable';
    }else if(item.type==2){
      column = 'is_chosen';
    }else if(item.type==4){
        column = 'validate_employee_id';
    }else{
      column = 'diamond';
    }

    let default_value =  item.value;
    if(column=='diamond' && this.now=='3' && item.value !=0){
      default_value = -1;//審核男生修改鑽石 強迫為-1 ; 如果改為免費仍可以是0
    }



    Object.keys(this.data).forEach(i => {
      const data = this.data[i].data;
      Object.keys(data).forEach(k => {
        if (this.tool_obj.process_list.includes(data[k].id)) {

                const index = this.alert_list.findIndex((v)=>{
                    return v == data[k].id;
                })

                if(index !=-1){
                    this.alert_list.splice(index,1);
                }

            if(column=='diamond' && this.data[i].data[k]['gender']*1==1 && item.value !=0){
              default_value = -1;//審核男生修改鑽石 強迫為-1 ; 如果改為免費仍可以是0
            }

            this.data[i].data[k][column] = default_value;

            this.alert_item(this.data[i].data[k],1,this.user.id);
        }
      });
    });

    // this.tool_obj.process_list = [];
  }

    save(){

        let data = [];
        if(this.now=='1'){
            data = this.data;
        }else{
            let temact = 0;
            let typeact = 0;
            let timeact = 0;
            this.alert_list = [];
            this.alert_pic_list = [];
            this.data_list.forEach((v,k) => {

                console.log('v',v);

                if(v.is_enable == -99){
                    if(v.tmp_checkUrl == null || v.tmp_checkUrl == undefined ){
                        this.alert_pic_list.push(v.id);
                        temact = 1;
                    }
                }

                if(v.is_enable == 6){
                    if(v.tmp_checkUrl == null || v.tmp_checkUrl == undefined ){
                        this.alert_pic_list.push(v.id);
                        temact = 1;
                    }
                }

                if(v.is_chosen == 1){
                    if(v.selectedDateTime == null || v.selectedDateTime == undefined ){
                        this.alert_pic_list.push(v.id);
                        typeact = 1;
                    }
                }

                if(v.is_chosen == 1){
                    if(v.timetype == null || v.timetype == undefined ){
                        this.alert_pic_list.push(v.id);
                        timeact = 1;
                    }
                }

                if(this.now=='2' && v.is_chosen == 0){
                    // this.data_list[k]['is_chosen'] = -1;//自動把沒被審的變成非精選
                }else if(this.now=='3' && v.validate_employee_id == 0 ){//補上emp id 表示審核過關了
                    this.data_list[k].validate_employee_id = this.user.id
                }else if(this.now=='4'&& v.validate_employee_id == 0 ){//補上emp id 表示審核過關了
                    this.data_list[k].validate_employee_id = this.user.id
                }
            });


            if(temact == 1){
                alert('盜圖未上圖片');
                return;
            }

            if(typeact == 1){
                alert('精選未選擇日期');
                return;
            }

            if(timeact == 1){
                alert('精選未選擇時間');
                return;
            }



            data = this.data_list;
        }

        this.loading = true;

        if(this.data_list.length > 0){
            const body = {tool:this.tool_obj,action:this.now,data:data,check_status_action:this.check_status_action,data_list:this.data_list};

            this.httpClient.post<any>("/update_storywall_v2.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    alert('執行成功');
                    this.tool_obj.process_list = [];
                    this.alert_list = [];
                    this.data_list = [];
                    this.init_list();
                }else{
                    alert('執行失敗');
                }
                console.log(res);
            }, error => {
                console.log(error);
            });
        }else{
            alert('未選取已審核選項');
            this.loading = false;
        }

    }

  go_top(){
    var btn_click = document.getElementById("go_top");
    const tmp = this.getOffset(btn_click);
		this.scrollAnimation(tmp.top,0);
  }

  getOffset (el) {
    const box = el.getBoundingClientRect();
    return{
      top: box.top + window.pageYOffset - document.documentElement.clientTop,
      left: box.left + window.pageXOffset - document.documentElement.clientLeft
    }
  }

  scrollAnimation(currentY, targetY) {
    let needScrollTop = targetY - currentY
    let _currentY = currentY
    setTimeout(() => {
      const dist = Math.ceil(needScrollTop / 10)
      _currentY += dist
      window.scrollTo(_currentY, currentY)
      if (needScrollTop > 10 || needScrollTop < -10) {
        this.scrollAnimation(_currentY, targetY)
      } else {
        window.scrollTo(_currentY, targetY)
      }
    }, 10)
  }

}
